<template>
  <div class="badge badge-warning entry_force" v-if="isVisible">
    社内登録モード
  </div>
</template>

<script>
export default {
  name: 'EntryForce',
  computed: {
    isVisible() {
      return this.$store.getters.isForceEntryMode
    }
  }
}
</script>